import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { CABINET_DATA } from "src/page-components/cabinet/constants";
import { NavigationSidebar } from "src/components/NavigationSidebar";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/redux/currentUser/selector";

const Cabinet: FC = () => {
  const { t } = useTranslation();
  const user = useAppSelector(selectCurrentUser);

  if (!user) return null;

  const { title, sidebarItems } = CABINET_DATA[user.host.role];

  const pageTitle =
    typeof title === "string" ? title : t(title.i18nKey, title.i18nParams);

  return (
    <PageWrapper mainClassName="py-25">
      <section className="container flex flex-col gap-2 xl:gap-10 !overflow-visible">
        <h1 className="font-semibold">{pageTitle}</h1>

        <div className="xl:flex items-start gap-3">
          <NavigationSidebar
            className="xl:min-w-73.5"
            sidebarItemClassName="!justify-start px-5 py-2 sm:py-3"
            items={sidebarItems}
          />

          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </section>
    </PageWrapper>
  );
};

export default Cabinet;
